import { GMAPS_API_KEY, GMAPS_COORDS_ACCM } from "../env";
import { MarkerClusterer } from "@googlemaps/markerclusterer";

let mapsScriptPromise = null;

export const Maps = {
    map: null,
    markers: [],
    polygon: null,
    clusterer: null,
    defaultCenter: { lat: 46.3330194, lng: 7.4841642 },
    markerClusterStyle: {
        styles: [{
            width: 30,
            height: 30,
            className: "custom-clustericon-1",
        },
            {
                width: 40,
                height: 40,
                className: "custom-clustericon-2",
            },
            {
                width: 50,
                height: 50,
                className: "custom-clustericon-3",
            }],
        clusterClass: "custom-clustericon"
    },
    defaultZoom: 10,

    init: async (container, limitMapToArea = "false", useClusters = false) => {
        if (typeof google === "undefined" || typeof google.maps === "undefined") {
            await Maps.loadGoogleMapsScript();
        }

        const mapElement = container;
        if (!mapElement) {
            console.warn('Map container null');
            return;
        }

        const mapTypeControl = (mapElement.dataset.mapTypeControl || "false").toLowerCase() === "true";
        const mapTypeControlPos = (mapElement.dataset.mapTypeControlPos || "topright").toLowerCase();

        const positions = {
            topleft: google.maps.ControlPosition.TOP_LEFT,
            topright: google.maps.ControlPosition.TOP_RIGHT,
            bottomleft: google.maps.ControlPosition.BOTTOM_LEFT,
            bottomright: google.maps.ControlPosition.BOTTOM_RIGHT
        };

        Maps.map = new google.maps.Map(mapElement, {
            center: Maps.defaultCenter,
            zoom: Maps.defaultZoom,
            mapId: container.getAttribute("id") || "maps-block",

            mapTypeControl: mapTypeControl,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            mapTypeControlOptions: {
                style: google.maps.MapTypeControlStyle.DEFAULT, // DEFAULT | DROPDOWN_MENU | HORIZONTAL_BAR
                position: positions[mapTypeControlPos] ?? google.maps.ControlPosition.TOP_RIGHT
            }
        });

        if (limitMapToArea == "true") {
            // polygons
            Maps.setPolygonArea(GMAPS_COORDS_ACCM.icogneLensCranm.reverse());
            /*this._setPolylineArea( this.coordsAreas.icogne );
            this._setPolygonArea( this.coordsAreas.lens );
            this._setPolygonArea( this.coordsAreas.cransm );*/

            // dotted lines
            //this._setPolylineArea( this.coordsAreas.icogneLensCranm );
            Maps.setPolylineArea(GMAPS_COORDS_ACCM.icogne);
            Maps.setPolylineArea(GMAPS_COORDS_ACCM.lens);
            Maps.setPolylineArea(GMAPS_COORDS_ACCM.cransm);
        }

        if (useClusters) {
            const renderer = {
                render: ({ count, position }) => {
                    const styles = Maps.markerClusterStyle.styles;
                    const cls =
                        count >= 50 ? styles[2] :
                            count >= 20 ? styles[1] : styles[0];

                    const div = document.createElement("div");
                    div.className = `${Maps.markerClusterStyle.clusterClass} ${cls.className}`;

                    const span = document.createElement("span");
                    span.textContent = String(count);

                    div.appendChild(span);

                    return new google.maps.marker.AdvancedMarkerElement({
                        position,
                        content: div,
                        zIndex: count,
                    });
                }
            };

            Maps.clusterer = new MarkerClusterer({
                map: Maps.map,
                markers: [],
                renderer
            });
        }
    },

    addMarker: (position, title = "", icon = null, onClick = null) => {
        if (!Maps.map) return;

        const marker = new google.maps.Marker({
            position,
            map: Maps.clusterer ? null : Maps.map,
            title,
            icon,
        });

        if (typeof onClick === "function") {
            marker.addListener("click", () => onClick(marker));
        }

        Maps.markers.push(marker);
        
        if (Maps.clusterer) {
            Maps.clusterer.addMarker(marker);
        }
        
        return marker;
    },

    clearMarkers: () => {
        if (Maps.clusterer) {
            Maps.clusterer.clearMarkers();
        }
        
        Maps.markers.forEach(marker => marker.setMap(null));
        Maps.markers = [];
    },

    fitToMarkers: () => {
        if (!Maps?.map || !Array.isArray(Maps.markers) || Maps.markers.length === 0) return;

        const positions = Maps.markers
            .map(m => (typeof m.getPosition === 'function' ? m.getPosition() : m.position))
            .filter(Boolean);

        if (positions.length === 1) {
            Maps.map.setCenter(positions[0]);
            //Maps.map.setZoom(typeof Maps.defaultZoom === 'number' ? Maps.defaultZoom : 11);
            return;
        }

        const bounds = new google.maps.LatLngBounds();
        positions.forEach(pos => bounds.extend(pos));
        if (!bounds.isEmpty()) {
            Maps.map.fitBounds(bounds, { top: 40, right: 40, bottom: 40, left: 40 });

            const once = google.maps.event.addListenerOnce(Maps.map, 'bounds_changed', () => {
                const maxZoom = 15;
                if (Maps.map.getZoom() > maxZoom) Maps.map.setZoom(maxZoom);
            });
        }
    },

    drawPolygon: (paths, options = {}) => {
        if (!Maps.map) return;

        if (Maps.polygon) {
            Maps.polygon.setMap(null);
        }

        Maps.polygon = new google.maps.Polygon({
            paths,
            strokeColor: options.strokeColor || "#FF0000",
            strokeOpacity: options.strokeOpacity || 0.8,
            strokeWeight: options.strokeWeight || 2,
            fillColor: options.fillColor || "#FF0000",
            fillOpacity: options.fillOpacity || 0.35,
            ...options,
        });

        Maps.polygon.setMap(Maps.map);
        return Maps.polygon;
    },

    setCenter: (latLng) => {
        if (Maps.map) {
            Maps.map.setCenter(latLng);
        }
    },

    setZoom: (zoomLevel) => {
        if (Maps.map) {
            Maps.map.setZoom(zoomLevel);
        }
    },


    setPolygonArea: function (coords) {
        const polyfillColor = '#FFFFFF',
            polyfillOpacity = 0.65; // 0.25 ;

        // covers the (mercator projection) world
        const outerbounds = [{ lat: 85, lng: 180 },
        { lat: 85, lng: 90 },
        { lat: 85, lng: 0 },
        { lat: 85, lng: -90 },
        { lat: 85, lng: -180 },
        { lat: 0, lng: -180 },
        { lat: -85, lng: -180 },
        { lat: -85, lng: -90 },
        { lat: -85, lng: 0 },
        { lat: -85, lng: 90 },
        { lat: -85, lng: 180 },
        { lat: 0, lng: 180 },
        { lat: 85, lng: 180 }
        ];

        new google.maps.Polygon({
            strokeOpacity: 1, //0,
            strokeWeight: 2, // 0,
            strokeColor: '#FFFFFF',
            fillColor: polyfillColor,
            fillOpacity: polyfillOpacity,
            clickable: false,
            paths: [
                outerbounds,
                coords],
            map: Maps.map
        });
    },

    setPolylineArea: function (coords) {
        const iconline = {
            path: google.maps.SymbolPath.CIRCLE,
            fillOpacity: 1,
            scale: 1.25
        },
            iconRepeat = '6px', // '5px',
            stroColor = '#e4584f'; // '#13391c' ; // '#e4584f';

        new google.maps.Polyline({
            strokeColor: stroColor,
            strokeOpacity: 0,
            clickable: false,
            icons: [{
                icon: iconline,
                offset: '0',
                repeat: iconRepeat
            }],
            path: coords,
            map: Maps.map
        })
    },

    loadGoogleMapsScript: (apiKey) => {
        if (typeof google !== "undefined" && google.maps) {
            return Promise.resolve();
        }

        if (mapsScriptPromise) {
            return mapsScriptPromise;
        }

        mapsScriptPromise = new Promise((resolve, reject) => {
            const existingScript = document.querySelector('script[src*="maps.googleapis.com/maps/api/js"]');
            if (existingScript) {
                existingScript.addEventListener("load", resolve);
                existingScript.addEventListener("error", reject);
                return;
            }

            const script = document.createElement("script");
            script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey ?? GMAPS_API_KEY}&libraries=marker`;
            script.async = true;
            script.defer = true;

            script.onload = resolve;
            script.onerror = reject;

            document.head.appendChild(script);
        });

        return mapsScriptPromise;
    },

    //for multi map in page 
    createInstance: async (container, limitMapToArea = "false", useClusters = false) => {
        if (typeof google === "undefined" || typeof google.maps === "undefined") {
            await Maps.loadGoogleMapsScript();
        }

        if (!container) {
            console.warn("Map container null");
            return null;
        }

        // Properties
        const mapTypeControl = (container.dataset.mapTypeControl || "false").toLowerCase() === "true";
        const mapTypeControlPos = (container.dataset.mapTypeControlPos || "topright").toLowerCase();

        const positions = {
            topleft: google.maps.ControlPosition.TOP_LEFT,
            topright: google.maps.ControlPosition.TOP_RIGHT,
            bottomleft: google.maps.ControlPosition.BOTTOM_LEFT,
            bottomright: google.maps.ControlPosition.BOTTOM_RIGHT
        };

        // Isoled instance
        const instance = {
            map: new google.maps.Map(container, {
                center: Maps.defaultCenter,
                zoom: Maps.defaultZoom,
                mapId: container.getAttribute("id") || "maps-block",

                mapTypeControl: mapTypeControl,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                mapTypeControlOptions: {
                    style: google.maps.MapTypeControlStyle.DEFAULT,
                    position: positions[mapTypeControlPos] ?? google.maps.ControlPosition.TOP_RIGHT
                }
            }),
            markers: [],
            clusterer: null,
            polygon: null,

            addMarker(position, title = "", icon = null, onClick = null) {
                const marker = new google.maps.Marker({
                    position,
                    map: this.clusterer ? null : this.map,
                    title,
                    icon,
                });

                if (typeof onClick === "function") {
                    marker.addListener("click", () => onClick(marker));
                }

                this.markers.push(marker);
                if (this.clusterer) this.clusterer.addMarker(marker);
                return marker;
            },

            clearMarkers() {
                if (this.clusterer) this.clusterer.clearMarkers();
                this.markers.forEach(marker => marker.setMap(null));
                this.markers = [];
            },

            fitToMarkers() {
                if (!this.map || this.markers.length === 0) return;

                const bounds = new google.maps.LatLngBounds();
                this.markers.forEach(m => bounds.extend(m.getPosition()));
                this.map.fitBounds(bounds);

                google.maps.event.addListenerOnce(this.map, "bounds_changed", () => {
                    const maxZoom = 15;
                    if (this.map.getZoom() > maxZoom) this.map.setZoom(maxZoom);
                });
            },

            setZoom(zoomLevel) {
                if (this.map) this.map.setZoom(zoomLevel);
            },

            setCenter(latLng) {
                if (this.map) this.map.setCenter(latLng);
            },

            setPolygonArea(coords) {
                const polyfillColor = "#FFFFFF",
                    polyfillOpacity = 0.65;

                // covers the (mercator projection) world
                const outerbounds = [
                    { lat: 85, lng: 180 }, { lat: 85, lng: 90 }, { lat: 85, lng: 0 },
                    { lat: 85, lng: -90 }, { lat: 85, lng: -180 }, { lat: 0, lng: -180 },
                    { lat: -85, lng: -180 }, { lat: -85, lng: -90 }, { lat: -85, lng: 0 },
                    { lat: -85, lng: 90 }, { lat: -85, lng: 180 }, { lat: 0, lng: 180 },
                    { lat: 85, lng: 180 }
                ];

                new google.maps.Polygon({
                    strokeOpacity: 1,
                    strokeWeight: 2,
                    strokeColor: "#FFFFFF",
                    fillColor: polyfillColor,
                    fillOpacity: polyfillOpacity,
                    clickable: false,
                    paths: [outerbounds, coords],
                    map: this.map
                });
            },

            setPolylineArea(coords) {
                const iconline = {
                    path: google.maps.SymbolPath.CIRCLE,
                    fillOpacity: 1,
                    scale: 1.25
                };
                const iconRepeat = "6px";
                const stroColor = "#e4584f";

                new google.maps.Polyline({
                    strokeColor: stroColor,
                    strokeOpacity: 0,
                    clickable: false,
                    icons: [{
                        icon: iconline,
                        offset: "0",
                        repeat: iconRepeat
                    }],
                    path: coords,
                    map: this.map
                });
            },
        };

        /*if (limitMapToArea === "true") {
            instance.setPolygonArea(GMAPS_COORDS_ACCM.icogneLensCranm.reverse());
            instance.setPolylineArea(GMAPS_COORDS_ACCM.icogne);
            instance.setPolylineArea(GMAPS_COORDS_ACCM.lens);
            instance.setPolylineArea(GMAPS_COORDS_ACCM.cransm);
        }*/

        // Clusters ---
        if (useClusters) {
            const renderer = {
                render: ({ count, position }) => {
                    const styles = Maps.markerClusterStyle.styles;
                    const cls =
                        count >= 50 ? styles[2] :
                        count >= 20 ? styles[1] : styles[0];

                    const div = document.createElement("div");
                    div.className = `${Maps.markerClusterStyle.clusterClass} ${cls.className}`;

                    const span = document.createElement("span");
                    span.textContent = String(count);
                    div.appendChild(span);

                    return new google.maps.marker.AdvancedMarkerElement({
                        position,
                        content: div,
                        zIndex: count,
                    });
                },
            };

            instance.clusterer = new MarkerClusterer({
                map: instance.map,
                markers: [],
                renderer
            });
        }

        return instance;
    }
};
